import React from 'react'

import {Check, formSpacing} from '../UI/forms/index.js'

class ParcelOptions extends React.Component {
    onChangeOptions(option) {
        const {selected, onChange} = this.props
        const index = selected.indexOf(option)

        if (index > -1) {
            selected.splice(index, 1)
        } else {
            selected.push(option)
        }
        onChange(selected)
    }

    render() {
        const {options, selected, disabledOptions} = this.props

        return (
            <>
                {!!options.length &&
                    <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', columnGap: formSpacing.columnGap, marginBottom: formSpacing.section}}>
                        {options.sort().map((option, index) => {
                            if (option !== 'Antwoordnummer' && option !== 'Postbus') {
                                return (
                                    <Check
                                        key={index}
                                        // Rows as high as the hover circle around the box, lower than a field so the list stays compact
                                        style={{width: 250, height: 36}}
                                        checked={selected.indexOf(option) > -1}
                                        label={option === 'Handtekening voor ontvangst' ? 'Handtekening' : option}
                                        onChange={this.onChangeOptions.bind(this, option)}
                                        disabled={disabledOptions.indexOf(option) > -1}
                                    />
                                )
                            }
                        })}
                    </div>
                }
            </>
        )
    }
}

export default (ParcelOptions)
